import templateUrl from 'emun.on-demand/templates/od-design-area-overlay-fieldset.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'

class DesignAreaOverlayFieldsetController {
    constructor() {
        basicController(this)
        const $ctrl = this;
        if(!this.type) this.type = 'Overlay';
    }
}

let DesignAreaOverlayFieldsetComponent = {
    bindings: {
        type: '@',
        area: '<',
        overlays: '=',
        onPositionOverlay: '&',
        onConfigureOverlay: '&',
        onPickOverlay: '&',
        onAddOverlay: '&',
        onRemoveOverlay: '&',
        onMoveOverlayUp: '&',
        onMoveOverlayDown: '&'
    },
    controller: DesignAreaOverlayFieldsetController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default DesignAreaOverlayFieldsetComponent;